export enum ScriveSigningPartyFieldType {
  Signature = 'Signature',
  SignatureDate = 'SignatureDate'
}
